import {
  GET_CHAPTER_LIST,
  GET_COURSES_LIST,
  GET_SUBJECT_LIST, 
} from "utils/graphql/services/global-content-hierarchy/queries";
import * as Yup from "yup";

export const table = {
  primaryData: [
    {
      title: "Course",
      value: "course",
      type: "configue",
    },
    {
      title: "Class",
      value: "class_name",
    },
    {
      title: "Subject",
      value: "subject",
      type: "configue",
    },
    {
      title: "Chapter",
      value: "chapter",
      type: "configue",
    },
    {
      title: "Status",
      value: "status",
    },
    // {
    //   title: "Actions",
    //   width: "5%",
    //   sendStatus: true,
    // },
  ],
  secondaryData: [
    {
      title: "Course Hierarchy Enabled",
      value: "is_course_hierarchy_enabled",
    },
    {
      title: "Program Hierarchy Enabled",
      value: "is_program_hierarchy_enabled",
    },
    {
      title: "Created At",
      value: "created_at",
      type: "configue",
    },
    {
      title: "Created By",
      value: "created_by_name",
      type: "configue",
    },
   
  ],
};

export type courseClassSubChapMap = {
  global_course_id: string;
  global_subject_id: string;
  global_chapter_id: string;
  status: string;
  is_course_hierarchy_enabled: string;
  is_program_hierarchy_enabled: string;
  class_id: string;
};

export const courseClassSubChapMapInitialValues: courseClassSubChapMap = {
  global_course_id: "",
  global_subject_id: "",
  global_chapter_id: "",
  status: "ACTIVE",
  is_course_hierarchy_enabled: "false",
  is_program_hierarchy_enabled: "false",
  class_id: "",
};

export const courseClassSubChapMapMandatoryFields = [
  {id: "class_id" },
  {id: "global_course_id" },
  {id: "global_subject_id" },
  {id: "global_chapter_id" },
];

export const courseClassSubChapMapValidationSchema = Yup.object().shape({
  global_course_id: Yup.number().required("course is required"),
  global_subject_id: Yup.number().required("subject is required"),
  global_chapter_id: Yup.number().required("chapter is required"),
  status: Yup.string().required("status is required"),
  class_id: Yup.string().required("class is required"),
});

export const courseClassSubChapMapProperties = [
  {
    id: "class_id",
    type: "single-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
    dependentFields: [""],
    dependentFlds: {},
  },
  {
    id: "global_course_id",
    type: "normal-select-search-only",
    label: "Course *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_course_list",
    keyValue: { label: "course_name", value: "id" },
    query: GET_COURSES_LIST,
    gqlKey: "getCourses",
    searchFieldKey: "course_name",
    mandatoryIds: ["gcf_public_course_id","npractice_practice_program_id"],
  },
  {
    id: "global_subject_id",
    type: "normal-select-search-only",
    label: "Subject *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_subject_list",
    keyValue: { label: "global_name", value: "id" },
    query: GET_SUBJECT_LIST,
    gqlKey: "getSubjects",
    searchFieldKey: "global_name",
    mandatoryIds:["gcf_public_subject_id", "npractice_practice_subject_id"],
  },
  {
    id: "global_chapter_id",
    type: "normal-select-search-only",
    label: "Chapter *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [],
    list: "gch_chapter_list",
    keyValue: { label: "global_name", value: "id" },
    query: GET_CHAPTER_LIST,
    gqlKey: "getChapters",
    searchFieldKey: "global_name",
    mandatoryIds:["gcf_public_chapter_id", "gcf_learn_chapter_id", "npractice_practice_chapter_id"],
  },
  {
    id: "is_program_hierarchy_enabled",
    type: "normal-select",
    label: "Program Hierarchy Enabled",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: true,
  },
  {
    id: "is_course_hierarchy_enabled",
    type: "normal-select",
    label: "Course Hierarchy Enabled",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: true,
  },
  {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];
